import * as React from 'react';
import { useDrag1dHandler } from './useDrag1dHandler';

/**
 * Encapsulates logic to resize an element vertically.
 *
 * @returns
 */
export function useResizeHandler(args: {
  /** external width
   *
   * always takes precedence over the drag with
   * and changing the given value chancels the resize
   */
  width: number;
  /** defaults to 42 */
  minWidth?: number;
  maxWidth?: number;
  /** Is called with the new width after the element was resized. Should be STABLE */
  handleResized?: (width: number) => void;
}): {
  /**
   * the current width of the element
   *
   * is the given (external) width when not dragging and the temporary size while dragging
   */
  width: number;
  isResizing: boolean;
  /** the event handlers to use on a drag-handler-element */
  resizeHandlers: NonNullable<
    Pick<
      React.DOMAttributes<HTMLElement>,
      'onMouseDown' | 'onMouseUp' | 'onTouchStart' | 'onTouchCancel' | 'onTouchEnd'
    >
  >;
} {
  const {
    handleResized: handleDragEnded,
    width: value,
    minWidth: minValue = 42,
    maxWidth: maxValue = Number.MAX_SAFE_INTEGER,
  } = args;

  const {
    value: width,
    isDragging: isResizing,
    dragHandlers: resizeHandlers,
  } = useDrag1dHandler({
    value,
    minValue,
    maxValue,
    handleDragEnded,
    direction: 'horizontal',
  });

  return {
    width,
    isResizing,
    resizeHandlers,
  };
}
